import { ChangeDetectionStrategy, Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'fi-user-reset-password',
    template: `
        <div class="form-group Selector">
            <p class="section-subname">
                <mat-icon class="section-name-icon" [ngClass]="getSendMagicLinkIconButton()"></mat-icon>
                <span>{{ getSendMagicLinkTextId() | fiAppText }}</span>
            </p>

            <ng-container>
                <p class="section-subname-description" [innerHTML]="'user.send_magic_link_description' | fiAppText"></p>

                <div class="Ccm-Data">
                    <mat-checkbox
                        [(ngModel)]="ngModel"
                        (ngModelChange)="doPropagateChanges()"
                        [disabled]="isMagicLinkCheckboxDisabled"
                    >
                        {{ 'yes' | fiAppText }}
                    </mat-checkbox>
                </div>
            </ng-container>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiUserResetPasswordComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiUserResetPasswordComponent,
        },
    ],
    host: { class: 'fi-user-reset-password' },
    standalone: false,
})
export class FiUserResetPasswordComponent extends ControlValueAccessorValidatorBase<boolean> {
    @Input() isAccessRequesting: boolean;
    @Input() isMagicLinkCheckboxDisabled: boolean;
    @Input() userId: number;

    constructor(injector: Injector) {
        super(injector);
    }

    getSendMagicLinkTextId(): string {
        return this.isAccessRequesting ? 'common.reset_password' : 'user.send_magic_link';
    }

    getSendMagicLinkIconButton(): string {
        return this.isAccessRequesting ? 'fas fa-redo' : 'fas fa-key';
    }

    isUserRequestReset(): boolean {
        return this.isAccessRequesting;
    }
}
